import React, {Fragment, useEffect} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {useParams} from 'react-router-dom';
import {getSalesReport} from "./actions";
import withPaging from "../common/withPaging";

const BooksSale = (props) => {

    const {eventId} = useParams();

    useEffect(() => {
        props.getSalesReport(eventId);
    }, []);

    const {salesReport} = props;
    if (!salesReport || !salesReport[eventId]) {
        return null;
    }
    const booksSales = salesReport[eventId].sales;

    return (
        <Fragment>
            {!eventId ?
                <div className="maximumSizeHandler">
                    <div className="contentTitle">
                        <span className=" font-size_24 boldFont middleContext">لیست سفارش‌ها</span>
                    </div>
                    <span className="lineSeparator"></span>
                </div> : null}
            <div className="maximumSizeHandler">
                <div className="tableStructure">
                    <table>
                        <tr className="font-size_16 mediumWFont">
                            <th></th>
                            <th>نام کتاب</th>
                            <th>تعداد فروخته شده</th>
                            <th>قیمت اصلی</th>
                            <th>تخفیف (درصد)</th>
                            <th>دریافتی</th>
                            <th/>
                        </tr>
                        {_.map(booksSales, booksSale => {
                            return (
                                <tr className="font-size_14">
                                    <td>
                                        <img src={booksSale.thumbnail} />
                                    </td>
                                    <td>{booksSale.name}</td>
                                    <td>{booksSale.count}</td>
                                    <td>{booksSale.originalAmount}</td>
                                    <td>{Math.round((booksSale.originalAmount - booksSale.salesAmount) / booksSale.originalAmount * 100)}</td>
                                    <td>{booksSale.salesAmount}</td>
                                    <td/>
                                </tr>
                            )
                        })
                    }
                    </table>
                </div>
            </div>
        </Fragment>
    );
}

const mapStateToProps = (state, ownProps) => ({
    salesReport: state.salesReport,
});

export default connect(mapStateToProps, {getSalesReport})(withPaging(BooksSale))